module.exports = __webpack_public_path__ + "static/FuturaPT-BoldObl-2c7f0f2c031843767b8fb72d979eb4ed.woff";